module.exports = __webpack_public_path__ + "img/selected-moment-of-bloom-2.445d32eb.webp";